import { useState } from "react";
import { Text, Flex, IconButton, Box } from "@chakra-ui/react";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { Card } from "@components";
import EPulseTimer from "./EPulseTimer";

const EPulseContainer = ({
  agenda,
  children,
  isMinimized,
  onToggleMinimize,
  currentEngagementLevel,
}) => {
  const getEngagementColor = (level) => {
    switch (level) {
      case "high":
        return "green.400";
      case "medium":
        return "yellow.400";
      case "low":
        return "red.400";
      case "no-data":
        return "gray.300";
      default:
        return "gray.400";
    }
  };

  return (
    <Card
      p="10px"
      position="relative"
      id="step4"
      data-testid="epulse-container"
      w="100%"
      transition="all 0.3s ease-in-out"
    >
      <Flex justifyContent="space-between">
        <Flex alignItems="center" gap="6px">
          {isMinimized && currentEngagementLevel !== "no-data" && (
            <Box
              width="13px"
              height="13px"
              borderRadius="50%"
              bg={getEngagementColor(currentEngagementLevel)}
              data-testid="epulse-indicator-dot"
              boxShadow="0 0 6px rgba(0,0,0,0.1)"
            />
          )}
          <Text fontSize="xs" fontWeight="400" color="dark.800" data-testid="epulse-title">
            Live Engagement Signal
          </Text>
        </Flex>
        <Flex alignItems="center" gap="2">
          <EPulseTimer agenda={agenda} />
          <IconButton
            aria-label={
              isMinimized ? "Expand E-Pulse chart" : "Minimize E-Pulse chart"
            }
            icon={isMinimized ? <ChevronDownIcon /> : <ChevronUpIcon />}
            size="sm"
            variant="ghost"
            onClick={onToggleMinimize}
            data-testid="epulse-toggle-button"
          />
        </Flex>
      </Flex>
      {!isMinimized && children}
    </Card>
  );
};

export default EPulseContainer;
